import React, {ReactNode} from 'react';

import MoreActionsItem from 'shared/ui/MoreActions/MoreActionsItem';
import MoreActionsDots from 'shared/ui/MoreActions/MoreActionsDots';

import styles from 'shared/ui/MoreActions/MoreActions.module.scss';
import {t} from '@lingui/core/macro';

interface IMHttpMonitorActionsProps {
     
    onEdit: () => void,
     
    onPause: () => void,
     
    onDelete: () => void,
     
    onCheck: () => void,
     
    onActive: () => void,
    status: string;
}

const MenuHttpMonitorHeader: React.FC<IMHttpMonitorActionsProps> = ({
    onEdit,
    onDelete,
    status,
    onPause,
    onActive,
    onCheck,
}) => {

    const getActions = (): ReactNode[] => {
        const actions: ReactNode[] = [];

        actions.push(
            <MoreActionsItem
                key="check"
                label={t`Проверить`}
                onClick={onCheck}/>,
        );

        if (status === 'active') {
            actions.push(
                <MoreActionsItem
                    key="pause"
                    label={t`Приостановить`}
                    onClick={onPause}
                />,
            );
        } else {
            actions.push(
                <MoreActionsItem
                    key="activate"
                    label={t`Включить`}
                    onClick={onActive}
                />,
            );
        }

        actions.push(
            <MoreActionsItem
                key="edit"
                label={t`Редактировать`}
                onClick={onEdit}/>,
        );

        actions.push(
            <MoreActionsItem
                key="delete"
                label={t`Удалить`}
                onClick={onDelete}/>,
        );

        return actions;
    };

    return (
        <div className={styles.container}>
            <MoreActionsDots>
                {
                    getActions().map(el => el)
                }
            </MoreActionsDots>
        </div>
    );
};

export default React.memo(MenuHttpMonitorHeader);